// extracted by mini-css-extract-plugin
export default {"modal":"EventsView_modal__wWGgr"};